import type { Notification } from "@storytell/client";
import {
  TbAlertCircle,
  TbBell,
  TbBroadcast,
  TbBrandSlack,
  TbCalendarEvent,
  TbCircleCheck,
  TbCoin,
  TbCreditCard,
  TbMailPlus,
  TbSparkles,
  TbUserCheck,
  TbUserMinus,
  TbUserPlus,
  TbUserShare,
  TbUserShield,
} from "solid-icons/tb";
import type { Component } from "solid-js";

interface NotificationIcon {
  icon: Component<{ class?: string; "aria-hidden"?: boolean }>;
  tone: string;
}

// Colors match the billing settings page (coin/amber for credits,
// calendar/purple for subscription events); unknown types get the neutral bell.
export function getNotificationIcon(n: Notification): NotificationIcon {
  switch (n.type) {
    case "activity.prompt.completed":
      return { icon: TbCircleCheck, tone: "text-emerald-500" };
    case "activity.prompt.failed":
      return { icon: TbAlertCircle, tone: "text-red-500" };
    case "billing.payment_failed":
    case "billing.auto_topup.failed":
      return { icon: TbCreditCard, tone: "text-red-500" };
    case "billing.credits.threshold":
    case "billing.auto_topup.cap_reached":
      return { icon: TbCoin, tone: "text-amber-500" };
    case "actions.transferred":
      return { icon: TbUserShare, tone: "text-sky-500" };
    case "session.invite":
      return { icon: TbUserPlus, tone: "text-indigo-500" };
    case "session.live":
      return { icon: TbBroadcast, tone: "text-red-500" };
    case "session.summary_ready":
      return { icon: TbSparkles, tone: "text-indigo-500" };
    case "org.invitation.received":
      return { icon: TbMailPlus, tone: "text-sky-500" };
    case "org.invitation.accepted":
      return { icon: TbUserCheck, tone: "text-emerald-500" };
    case "org.role.changed":
      return { icon: TbUserShield, tone: "text-indigo-500" };
    case "org.member.removed":
      return { icon: TbUserMinus, tone: "text-red-500" };
    case "integrations.slack.update_needed":
      return { icon: TbBrandSlack, tone: "text-amber-500" };
    default:
      if (n.type.startsWith("billing.subscription.")) {
        return { icon: TbCalendarEvent, tone: "text-purple-500" };
      }
      return { icon: TbBell, tone: "text-muted-text" };
  }
}
